import { Component, OnInit } from '@angular/core';
import { ASSETS_API_URL } from '@app/app.constants';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { RedirectRouterService } from '@shared/services/web/redirect-router.service';
import packageInfo from '../../../../package.json';
import { filter } from 'rxjs';
import { ToastrService } from '@shared/services/web/toastr.service';
import { WeCallYouComponent } from '@app/@shared/components/we-call-you/we-call-you.component';
import { SignInModalComponent } from '@app/security/modals/sign-in-modal/sign-in-modal.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public picturesServer = ASSETS_API_URL;
  public flagAreaPrivada = false;
  versionado: any;
  language = '';

  constructor(
    public translateService: TranslateService,
    private readonly router: Router,
    public dialog: MatDialog,
    private redirectService: RedirectRouterService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.language = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.language = event.lang;
    });
    this.versionado = packageInfo.version;
    this.flagAreaPrivada = this.router.url.includes('tablero-de-usuario');
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        event.url.includes('tablero-de-usuario')
          ? (this.flagAreaPrivada = true)
          : (this.flagAreaPrivada = false);
      });
  }

  goNavigateToUrl(path: string): string | void {
    if (
      !this.router.url.includes('invertir/propiedad') &&
      (this.router.url.includes('invertir') ||
        this.router.url.includes('invertir?'))
    ) {
      return '';
    } else {
      sessionStorage.removeItem('search');
      const customCreateUrl = `/${path}`;
      this.redirectService.goToPage(customCreateUrl);
    }
  }

  openSignInModal() {
    this.dialog.open(SignInModalComponent, {
      maxWidth: '95vw',
      panelClass: 'icon-logo-modal',
      id: 'sign-in-modal-header',
    });
  }

  openCallModal() {
    const isMobile = window.innerWidth <= 768;
    this.dialog.open(WeCallYouComponent, {
      maxWidth: '95vw',
      panelClass: 'noPadding',
    });
  }
  getPath() {
    return window.location.pathname.includes('/invertir/propiedad');
  }
}
